import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import image1 from 'assets/image/image-1.png'
const CarouselNavigate = ({ setOpenTray }) => {
    return (
        <>
            <Carousel showThumbs={false} width={"auto"} dynamicHeight={true} height="10">
                <div>
                    <div className="button-on">
                        <h2 style={{ padding: 20, fontWeight: "bold" }}>WELCOME LOREM IPSUM DOLOR SIT AMET</h2>
                        <div onClick={setOpenTray} className="button-click-header"><i className="fa-solid fa-hand-pointer fa-1x"></i> Let's Get Started The Apps </div>
                    </div>
                    <img alt="test-app" src={image1} />
                </div>
            </Carousel>
        </>
    )
}

export default CarouselNavigate